import { QueryClient } from '@tanstack/react-query';

// The app's single TanStack Query client. Imported by App.tsx for the provider and by
// logoutCleanup so logging out clears the same cache the app reads from.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 3,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
